module.exports = __webpack_public_path__ + "static/media/galeria4.edfefe55.jpg";